"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const ValueObject_1 = require("../Common/ValueObject");
exports.FudaoVersion = 1;
exports.FudaoEventCategory = "Fudao";
exports.FudaoCommandCategory = "Fudao";
var Status;
(function (Status) {
    Status["None"] = "None";
    Status["Created"] = "Created";
    Status["Starting"] = "Starting";
    Status["Started"] = "Started";
    Status["Ended"] = "Ended";
    Status["AbnormalEnded"] = "AbnormalEnded";
    Status["Interrupted"] = "Interrupted";
})(Status = exports.Status || (exports.Status = {}));
class StatusMethods {
    static IsEnded(status) {
        return status === Status.Ended || status === Status.AbnormalEnded || status === Status.Interrupted;
    }
}
exports.StatusMethods = StatusMethods;
var InvitingStatus;
(function (InvitingStatus) {
    InvitingStatus["None"] = "None";
    InvitingStatus["InvitingSent"] = "InvitingSent";
    InvitingStatus["InvitingCanceled"] = "InvitingCanceled";
    InvitingStatus["InvitingAccepted"] = "InvitingAccepted";
    InvitingStatus["InvitingRejected"] = "InvitingRejected";
})(InvitingStatus = exports.InvitingStatus || (exports.InvitingStatus = {}));
var FudaoSessionType;
(function (FudaoSessionType) {
    FudaoSessionType["Unknown"] = "Unknown";
    FudaoSessionType["TeacherVideo"] = "TeacherVideo";
    FudaoSessionType["Audio"] = "Audio";
    FudaoSessionType["Whiteboard"] = "Whiteboard";
    FudaoSessionType["Data"] = "Data";
})(FudaoSessionType = exports.FudaoSessionType || (exports.FudaoSessionType = {}));
class FudaoSession extends ValueObject_1.ValueObject {
    constructor(para) {
        super();
        this.Id = "";
        this.SessionType = FudaoSessionType.Unknown;
        this.Id = para.Id || this.Id;
        this.SessionType = para.SessionType || this.SessionType;
    }
    *GetEqualityComponents() {
        yield* [this.Id, this.SessionType];
    }
    IsValid() {
        return !TypeScriptUtils_1.isNullOrEmpty(this.Id) && (this.SessionType !== FudaoSessionType.Unknown);
    }
    static Create(id, sessionType) {
        return new FudaoSession({
            Id: id,
            SessionType: sessionType,
        });
    }
}
FudaoSession.INVALID_FUDAO_SESSION = new FudaoSession({
    Id: "",
    SessionType: FudaoSessionType.Unknown
});
exports.FudaoSession = FudaoSession;
class FudaoSessionInvitingStatus extends ValueObject_1.ValueObject {
    constructor(fs, invitingStatus) {
        super();
        this.Session = fs;
        this.InvitingStatus = invitingStatus;
    }
    *GetEqualityComponents() {
        yield* [this.Session, this.InvitingStatus];
    }
    get SessionId() { return this.Session.Id; }
}
FudaoSessionInvitingStatus.INVAID_FUDAO_INVITING_STATUS = new FudaoSessionInvitingStatus(FudaoSession.INVALID_FUDAO_SESSION, InvitingStatus.None);
exports.FudaoSessionInvitingStatus = FudaoSessionInvitingStatus;
//# sourceMappingURL=FudaoDefinition.js.map